import { BadgePDF } from './extensions/pdf/BadgePDF';
import { Nullable } from '../types/common';
import { Options, PDFBadgeInfo } from '../types/badge';
import { DownloadFileTypes, IMAGE_TYPES } from '../types/enums';
import { ImageExtension } from './extensions/image/ImageExtension';
import { ZPL } from './zpl/ZPL';
import LanguageHelper from '../common/helpers/language/LanguageHelper';
import EventEditionHelper from '../common/helpers/eventEdition/EventEditionHelper';

export class Badge {
  private badgeInfo: PDFBadgeInfo;

  constructor(badgeInfo: PDFBadgeInfo) {
    this.badgeInfo = badgeInfo;
  }

  getBadgeInfo() {
    return this.badgeInfo;
  }

  updateBadgeInfo(badgeInfo: PDFBadgeInfo) {
    this.badgeInfo = badgeInfo;
  }

  static blobToBase64(blob: Blob): Promise<Nullable<string>> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  }

  async get(type: DownloadFileTypes, options: Options, eventLocale: string) {
    LanguageHelper.locale = eventLocale;
    EventEditionHelper.businessUnitCode = options.businessUnitCode;
    console.log('Generating badge...');
    if (type === DownloadFileTypes.PDF) {
      return new BadgePDF().getBlob({ ...options, type }, this.badgeInfo);
    }
    if (type === DownloadFileTypes.ZPL) {
      const blob = await new BadgePDF().getBlob({ ...options, type }, this.badgeInfo);
      const { image } = await ImageExtension.getImageFromPDF(blob!, IMAGE_TYPES.PNG, options.zplOptions);
      return ZPL.getZPL64FromImage(image, { black: 60, notrim: true });
    }
  }
}
